module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "ErrorDemoH5");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ErrorDemoH5!./src/pages/ErrorDemo/index.js
// module id = 676
// module chunks = 438